import { render, staticRenderFns } from "./AgregarTickets.vue?vue&type=template&id=b38c7888"
import script from "./AgregarTickets.vue?vue&type=script&lang=js"
export * from "./AgregarTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports